__webpack_require__.p = "https://webapps.nku.edu/degreemap/";